'use client';

import { Stack, Typography } from '@mui/material';
import Image from 'next/image';

import { icons } from '@/assets/icons';
import HexagonalButton from '@/components/bases/HexagonalButton';

export const StayConnectedSection = () => {
  return (
    <Stack
      width={'100%'}
      height={'100%'}
      flexGrow={1}
      padding={{ xs: '40px 24px', md: '40px 80px' }}
      alignItems={'center'}
      component={'section'}
      position={'relative'}>
      <Stack width={'min(1280px, 100%)'} zIndex={2}>
        <Stack
          alignItems={'center'}
          direction={{ xs: 'column', md: 'row' }}
          justifyContent={'space-between'}
          gap={{ xs: '40px', md: '80px' }}
          width={'100%'}>
          <Image
            priority
            src={icons.ic_graphic_discord}
            alt={'discord'}
            width={413}
            height={357}
            className={'w-[207px] md:w-[413px] h-[179px] md:h-[357px]'}
          />
          <Stack gap={{ xs: 3, md: 7 }} width={'100%'}>
            <Stack gap={{ xs: 2, md: 3 }} width={'100%'}>
              <Typography
                component={'h2'}
                variant={'displayMedium'}
                className={'clip-text'}
                fontSize={{ xs: '24px', md: '48px' }}
                lineHeight={{ xs: '32px', md: '68px' }}
                textAlign={{ xs: 'center', md: 'left' }}
                sx={{ background: 'linear-gradient(90deg, #A9A9A9 0%, #FFFFFF 50%, #A9A9A9 100%)' }}>
                STAY <span style={{ WebkitTextFillColor: '#FF6B00' }}>CONNECTED</span>
              </Typography>
              <Typography
                fontSize={{ xs: '14px', md: '18px' }}
                component={'h4'}
                variant={'bodyLarge'}
                color={'#FFFFFF'}
                className={'mix-blend'}
                textAlign={{ xs: 'center', md: 'left' }}>
                We move fast with the community in mind. Join the LFG movement.
              </Typography>
            </Stack>
            <Stack width={247} display={{ xs: 'none', md: 'block' }} sx={{ margin: { xs: '0 auto', md: 'unset' } }}>
              <HexagonalButton
                label={'JOIN LFG DISCORD'}
                onClick={() => window.open('https://discord.gg/PjTfVJh4Wr', '_blank')}
              />
            </Stack>
            <Stack width={182} display={{ xs: 'block', md: 'none' }} sx={{ margin: { xs: '0 auto', md: 'unset' } }}>
              <HexagonalButton
                size={'small'}
                label={'JOIN LFG DISCORD'}
                onClick={() => window.open('https://discord.gg/PjTfVJh4Wr', '_blank')}
              />
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
